<template>
	<div>
		<div class=" margin-top" style="display: flex;align-items: center;">
			<div class="el-descriptions__title" style="margin-right: 20px;white-space:nowrap">
				阶段选择
			</div>
			<el-radio-group v-model="radio" :data="domains">
				<el-radio v-for="(a, b) in domains" :key="b" :label="a">第{{ b + 1 }}阶段({{ a.statime }} 至
					{{ a.endtime }})</el-radio>
			</el-radio-group>
			<el-button @click="jieduan" type="primary" style="margin-left: 30px;" size="mini">新增阶段</el-button>
			<el-button @click="shuaxin" type="primary" style="margin-left: 30px;" size="mini">刷新数据</el-button>
			
			<el-date-picker  size="mini" style="width: 7vw;  margin-left: 30px; font-size: 90%;"  v-model="years" type="year" placeholder="年度切换">
			</el-date-picker>
		  
			<!-- 选择时间都在段 -->
			<el-dialog title="请定义阶段" :visible.sync="dialogVisible" :closeOnClickModal="false" width="80%"
				:before-close="handleClose">
				<span slot="footer" class="dialog-footer">
					<el-form ref="domains" class="demo-dynamic" v-for="(domain, index) in domains">
						<el-form-item v-model="domain.index" :label="'阶段' + (index + 1)" :key="domain.domain">
						</el-form-item>

						<!-- <div v-if="index == 0"> -->
						<el-form-item :label="'开始时间'" :key="domain.domain" :prop="'domains.' + index + '.statime'">
							<div class="block">
								<el-date-picker v-model="domain.statime" type="month" value-format="yyyy-MM"
									placeholder="选择日期">
									{{ domain.statime }}
								</el-date-picker>
							</div>
						</el-form-item>
						<el-form-item :label="'结束时间'" :key="domain.domain" :prop="'domains.' + index + '.endtime'">
							<div class="block">
								<el-date-picker v-model="domain.endtime" type="month" value-format="yyyy-MM"
									placeholder="选择日期">
									{{ domain.endtime }}
								</el-date-picker>
							</div>
						</el-form-item>
						<el-button @click.prevent="removeDomain(domain)">删除</el-button>
						<el-form-item>
						</el-form-item>
					</el-form>
					<el-button type="primary" @click="submitForm('domains')">确定</el-button>
					<el-button @click="addDomain">新增阶段</el-button>

					<el-button @click="dialogVisible = false">取 消</el-button>
				</span>
			</el-dialog>
			<!-- 选择时间都在段 -->
			<!-- 选中其中一时间段后选中机构发布任务 -->
			<el-dialog title="请选择机构" :visible.sync="dialogVisibles" :closeOnClickModal="false" width="80%"
				:before-close="handleClosev1">
				<span slot="footer" class="dialog-footer">
					<div class="box1">
						<el-table ref="multipleTable" height="calc( 100vh - 350px)" :data="hosps" tooltip-effect="dark"
							style="width: 100%;" @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55">
							</el-table-column>
							<el-table-column type="index" label="序号" width="50">
							</el-table-column>
							<el-table-column prop="label" label="机构名">
							</el-table-column>
						</el-table>
					</div>
					<el-button @click="Task" v-loading.fullscreen.lock="fullscreenLoading">发布任务</el-button>
					<el-button @click="quxiao">取 消</el-button>
				</span>
			</el-dialog>
			<!-- 选中其中一时间段后选中机构发布任务 -->


		</div>
		<div class=" margin-top" style="display: flex;align-items: center; margin-top: 5px;">
			<el-button-group>
				<el-button @click="bbtype = 0" size="mini" type="primary">机构报表</el-button>
				<el-button @click="bbtype = 1" size="mini" type="warning">送训费报表(家长未确认)</el-button>
				<el-button @click="bbtype = 5" size="mini" type="primary">送训费报表(家长已确认)</el-button>
				<el-button icon="el-icon-download" size="mini" @click="daochu" type="success">导出</el-button>
			</el-button-group>
			<el-button-group style="margin-left: 20px;">
				<el-button @click="bbtype = 2" size="mini" type="danger">未确认的机构</el-button>
				<el-button @click="bbtype = 3" size="mini" type="warning">未拨款的机构</el-button>
				<el-button icon="el-icon-download" @click="bbtype = 4" size="mini" type="success">已完成机构</el-button>
			</el-button-group>
		</div>


		<!-- 机构报表 -->
		<div v-if="bbtype == 0">
			<el-button style="margin-top: 3px;margin-bottom: 5px;" size="mini" type="primary">机构报表</el-button>
			<el-table :data="arrays" height="calc( 100vh - 280px)" border style="width: 95%;">

				<el-table-column type="index" label="序号"></el-table-column>
				<el-table-column prop="org_name" label="机构名"></el-table-column>
				<el-table-column prop="stu" label="学生数"></el-table-column>
				<el-table-column prop="statime" label="开始时间"></el-table-column>
				<el-table-column prop="endtime" label="结束时间"></el-table-column>
				
				

				<el-table-column prop="zhuangtai" label="状态">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.zhuangtai == 1" size="mini" type="primary">已完成</el-button>
							<el-button v-else size="mini" type="warning">未完成</el-button></span>
					</template>
				</el-table-column>



				<el-table-column prop="money_sum" label="康复费用"></el-table-column>
				<el-table-column prop="sxf" label="送训费合计"></el-table-column>
				<el-table-column prop="chuqin" label="出勤表">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.chuqin == '0'" size="mini"
								type="warning">暂无数据</el-button>
							<el-button @click="downloadFile(scope.row)" v-else size="mini"
								type="primary">下载出勤表</el-button></span>
					</template>
				</el-table-column>
				<el-table-column prop="money_img" label="资金发票">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.money_img == 'https://api.heiban.icu/null'" size="mini"
								type="warning">暂无发票</el-button>
							<el-button @click="chakanfapapiao(scope.row)" v-else size="mini"
								type="primary">查看发票</el-button></span>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 送训费报表 -->
		<div>
			<el-button v-if="bbtype == 1" style="margin-top: 5px;margin-bottom: 5px;" size="mini"
				type="warning">送训费报表(家长未确认)</el-button>
			<template>
				<el-table v-if="bbtype == 1" :data="arrayss0"  border 
					stripe class="system-table" height="calc( 100vh - 280px)" @row-click="clickRowHandle" style="width: 100%">
					<el-table-column type="expand">
						<div slot-scope="props">
							<el-form label-position="left" inline class="demo-table-expand">
								<el-form-item label="上限天数">
									<span>{{ props.row.day_s }}</span>
								</el-form-item>
								<el-form-item label="真实天数">
									<span>{{ props.row.day_z }}</span>
								</el-form-item>
								<el-form-item label="残疾类型">
									<span>{{ props.row.stu_disability }}</span>
								</el-form-item>
								<el-form-item label="类型">
									<span>{{ props.row.type }}</span>
								</el-form-item>
								<el-form-item label="学生身份证">
									<span>{{ props.row.stu_ID }}</span>
								</el-form-item>
								<el-form-item label="资金结算开始时间">
									<span>{{ props.row.start_time_stu }}</span>
								</el-form-item>
								<el-form-item label="资金结算结束时间">
									<span>{{ props.row.end_time_stu }}</span>
								</el-form-item>
							</el-form>
						</div>
					</el-table-column>
					<el-table-column type="index" label="序号"></el-table-column>
					<el-table-column prop="stu_name" label="学生名"></el-table-column>
					<el-table-column prop="yhcarid" label="银行卡号"></el-table-column>
					<el-table-column prop="sxf" label="送训费"></el-table-column>
					<el-table-column prop="day_z" label="累计天数"></el-table-column>
					<el-table-column prop="stu_id_qr" label="状态">
						<template slot-scope="scope">
							<el-button size="mini" type="warning">家长未确认</el-button>

						</template>
					</el-table-column>
				</el-table>
			</template>
		</div>

		<div>
			<el-button v-if="bbtype == 5" style="margin-top: 5px;margin-bottom: 5px;" size="mini"
				type="primary">送训费报表(家长已确认)</el-button>
			<template>

				<el-table v-if="bbtype == 5" :data="arrayss1"  stripe
					class="system-table" height="calc( 100vh - 280px)" @row-click="clickRowHandle" style="width: 100%">

					<el-table-column type="expand">
						<div slot-scope="props">
							<el-form label-position="left" inline class="demo-table-expand">
								<el-form-item label="上限天数">
									<span>{{ props.row.day_s }}</span>
								</el-form-item>
								<el-form-item label="真实天数">
									<span>{{ props.row.day_z }}</span>
								</el-form-item>
								<el-form-item label="残疾类型">
									<span>{{ props.row.stu_disability }}</span>
								</el-form-item>
								<el-form-item label="类型">
									<span>{{ props.row.type }}</span>
								</el-form-item>
								<el-form-item label="学生身份证">
									<span>{{ props.row.stu_ID }}</span>
								</el-form-item>
								<el-form-item label="资金结算开始时间">
									<span>{{ props.row.start_time_stu }}</span>
								</el-form-item>
								<el-form-item label="资金结算结束时间">
									<span>{{ props.row.end_time_stu }}</span>
								</el-form-item>
							</el-form>
						</div>
					</el-table-column>
					<el-table-column type="index" label="序号"></el-table-column>
					<el-table-column prop="stu_name" label="学生名"></el-table-column>
					<el-table-column prop="yhcarid" label="银行卡号"></el-table-column>
					<el-table-column prop="sxf" label="送训费"></el-table-column>
					<el-table-column prop="day_z" label="累计天数"></el-table-column>
					<el-table-column prop="stu_id_qr" label="状态">
						<template slot-scope="scope">
							<el-button size="mini" type="primary">家长已确认</el-button>

						</template>
					</el-table-column>
				</el-table>
			</template>
		</div>



		<!-- 未核对机构上报资金数  未确认的机构  org_qr  -->
		<div>
			<el-button v-if="bbtype == 2" style="margin-top: 5px;margin-bottom: 5px;" size="mini"
				type="danger">未确认的机构</el-button>
			<el-table v-if="bbtype == 2" height="calc( 100vh - 280px)" :data="unqueren"  border style="width: 95%;">

				<el-table-column type="index" label="序号"></el-table-column>
				<el-table-column prop="org_name" label="机构名"></el-table-column>
				<el-table-column prop="stu" label="学生数"></el-table-column>
				<el-table-column prop="statime" label="开始时间"></el-table-column>
				<el-table-column prop="endtime" label="结束时间"></el-table-column>

				<el-table-column prop="zhuangtai" label="状态">	
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.zhuangtai == 1" size="mini" type="primary">已完成</el-button>
							<el-button v-else size="mini" type="warning">未完成</el-button></span>
					</template>
				</el-table-column>
				<el-table-column prop="money_sum" label="康复费用"></el-table-column>
				<el-table-column prop="sxf" label="送训费合计"></el-table-column>
				<el-table-column prop="chuqin" label="出勤表">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.chuqin == '0'" size="mini"
								type="warning">暂无数据</el-button>
							<el-button @click="downloadFile(scope.row)" v-else size="mini"
								type="primary">下载出勤表</el-button></span>
					</template>
				</el-table-column>
				<el-table-column prop="money_img" label="资金发票">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.money_img == 'https://api.heiban.icu/null'" size="mini"
								type="warning">暂无发票</el-button>
							<el-button @click="chakanfapapiao(scope.row)" v-else size="mini"
								type="primary">查看发票</el-button></span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<el-button @click="bohuiv2(scope.row)" type="danger" size="mini">驳回</el-button>
						<el-button @click="handleClickv2(scope.row)" size="mini" type="primary">确认资金</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 未拨款机构 -->
		<div>
			<el-button v-if="bbtype == 3" style=" margin-top: 5px;margin-bottom: 5px;" size="mini"
				type="warning">未拨款的机构</el-button>
			<el-table v-if="bbtype == 3" height="calc( 100vh - 280px)" border :data="nomoney" style="width: 95%;">

				<el-table-column type="index" label="序号"></el-table-column>
				<el-table-column prop="org_name" label="机构名"></el-table-column>
				<el-table-column prop="stu" label="学生数"></el-table-column>
				<el-table-column prop="statime" label="开始时间"></el-table-column>
				<el-table-column prop="endtime" label="结束时间"></el-table-column>
				<el-table-column prop="zhuangtai" label="状态">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.zhuangtai == 1" size="mini" type="primary">已完成</el-button>
							<el-button v-else size="mini" type="warning">未完成</el-button></span>
					</template>
				</el-table-column>
				<el-table-column prop="money_sum" label="康复费用"></el-table-column>
				<el-table-column prop="sxf" label="送训费合计"></el-table-column>
				<el-table-column prop="chuqin" label="出勤表">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.chuqin == '0'" size="mini"
								type="warning">暂无数据</el-button>
							<el-button @click="downloadFile(scope.row)" v-else size="mini"
								type="primary">下载出勤表</el-button></span>
					</template>
				</el-table-column>
				<el-table-column prop="money_img" label="资金发票">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.money_img == 'https://api.heiban.icu/null'" size="mini"
								type="warning">暂无发票</el-button>
							<el-button @click="chakanfapapiaov1(scope.row)" v-else size="mini"
								type="primary">查看发票</el-button></span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<!-- <el-button @click="bohuiv3(scope.row)" type="danger" size="mini">驳回</el-button> -->
						<el-button @click="handleClickv3(scope.row)" size="mini" type="primary">确认拨款</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 残联已拨款机构 -->

		<div>
			<el-button v-if="bbtype == 4" style=" margin-top: 5px;margin-bottom: 5px;" size="mini"
				type="success">已完成机构</el-button>
			<el-table v-if="bbtype == 4" height="calc( 100vh - 280px)" border :data="wancheng" style=" width: 95%;">
				<el-table-column type="index" label="序号"></el-table-column>
				<el-table-column prop="org_name" label="机构名"></el-table-column>
				<el-table-column prop="stu" label="学生数"></el-table-column>
				<el-table-column prop="statime" label="开始时间"></el-table-column>
				<el-table-column prop="endtime" label="结束时间"></el-table-column>
				<el-table-column prop="zhuangtai" label="状态">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.zhuangtai == 1" size="mini" type="primary">已完成</el-button>
							<el-button v-else size="mini" type="warning">未完成</el-button></span>
					</template>
				</el-table-column>
				<el-table-column prop="money_sum" label="康复费用"></el-table-column>
				<el-table-column prop="sxf" label="送训费合计"></el-table-column>
				<el-table-column prop="chuqin" label="出勤表">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.chuqin == '0'" size="mini"
								type="warning">暂无数据</el-button>
							<el-button @click="downloadFile(scope.row)" v-else size="mini"
								type="primary">下载出勤表</el-button></span>
					</template>
				</el-table-column>
				<el-table-column prop="money_img" label="资金发票">
					<template slot-scope="scope">
						<span><el-button v-if="scope.row.money_img == 'https://api.heiban.icu/null'" size="mini"
								type="warning">暂无发票</el-button>
							<el-button @click="chakanfapapiao(scope.row)" v-else size="mini"
								type="primary">查看发票</el-button></span>
					</template>
				</el-table-column>
				<!-- <el-table-column fixed="right" label="操作" width="150">
				<template slot-scope="scope">
					<el-button @click="handleClick(scope.row)" size="mini" type="primary">确认</el-button>
				</template>
			</el-table-column> -->
			</el-table>
		</div>

		<!-- 查看发票 -->
		<el-dialog title="提示" :visible.sync="dialogVisiblev1" width="30%" :before-close="handleClose">
			<span>点击可放大查看</span>
			<div class="demo-image__preview">
				<el-image style="width: 100px; height: 100px" :src="url" :preview-src-list="srcList">
				</el-image>
			</div>
			<el-button @click="dialogVisiblev1 = false">取 消</el-button>
			<el-button type="primary" @click="dialogVisiblev1 = false">确 定</el-button>
		</el-dialog>

		<!-- 确认拨款前发票提示 -->
		<el-dialog title="提示" :visible.sync="dialogVisiblev2" width="30%" >
			<span>点击可放大查看</span>
			<div class="demo-image__preview">
				<el-image style="width: 100px; height: 100px" :src="url" :preview-src-list="srcList">
				</el-image>
			</div>
			<div v-if="orgneirong.fp_status==1"><el-button @click="dialogVisiblev2 = false">取 消</el-button>
			<el-button type="primary" @click="dialogVisiblev2 = false">确 定</el-button></div>
			<div v-else><el-button style="margin-right: 10px;" @click="bohuiv3" type="danger" size="mini">驳回发票</el-button>
			<el-button type="primary" size="mini" @click="fp_statuss">确定发票</el-button></div>
		</el-dialog>

		<!-- 导出表弹窗 -->
		<el-dialog title="请选择要导出的报表" :visible.sync="dialogVisiblevd" width="30%" :before-close="handleClose">
			<el-select v-model="value" placeholder="请选择">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>

			<span slot="footer" class="dialog-footer">
				<div v-if="value == '机构报表'">
					<download-excel class="export-excel-wrapper" :data="arrays" :fields="json_field1" type="xls"
						worksheet="My Worksheet" name="机构报表">
						<el-button @click="daochubiao">导出EXCEL</el-button>
					</download-excel>
				</div>
				<div v-if="value == '送训费报表(家长未确认)'">
					<download-excel class="export-excel-wrapper" :data="arrayss0" :fields="json_field2" type="xls"
						worksheet="My Worksheet" name="送训费报表(家长未确认)">
						<el-button @click="daochubiao">导出EXCEL</el-button>
					</download-excel>
				</div>
				<div v-if="value == '送训费报表(家长已确认)'">
					<download-excel class="export-excel-wrapper" :data="arrayss1" :fields="json_field2" type="xls"
						worksheet="My Worksheet" name="送训费报表(家长已确认)">
						<el-button @click="daochubiao">导出EXCEL</el-button>
					</download-excel>
				</div>
			</span>
		</el-dialog>


	</div>
</template>



<script>

import XLSX from 'xlsx'
import { Loading } from 'element-ui';



export default {
	data() {
		return {
			duibi: [],
			years: new Date(),
			value: '',
			json_field1: {
				机构名: "org_name",
				学生数: "stu",
				康复费用: "money_sum",
				出勤表: "chuqin",
				送训费合计: "sxf",
				结算开始时间: "statime",
				结算结束时间: "endtime",

			},
			json_field2: {
				学生名: "stu_name",
				银行卡号: "yhcarid",
				送训费合计: "sxf",
				累计天数: "day_z",
				上限天数: "day_s",
				真实天数: "day_z",
				残疾类型: "stu_disability",
				类型: "type",
				学生身份证: "stu_ID",
				结算开始时间: "start_time_stu",
				结算结束时间: "end_time_stu",
			},
			json_field2: {
				学生名: "stu_name",
				银行卡号: "yhcarid",
				送训费合计: "sxf",
				累计天数: "day_z",
				上限天数: "day_s",
				真实天数: "day_z",
				残疾类型: "stu_disability",
				类型: "type",
				学生身份证: "stu_ID",
				结算开始时间: "start_time_stu",
				结算结束时间: "end_time_stu",
			},
			options: [
				{
					value: '机构报表',
					label: '机构报表'
				}, {
					value: '送训费报表(家长未确认)',
					label: '送训费报表(家长未确认)'
				},
				{
					value: '送训费报表(家长已确认)',
					label: '送训费报表(家长已确认)'
				},
			],
			url: '',
			srcList: [],
			getRowKeys(row) {
				return row.id;
			},
			// 要展开的行，数值的元素是row的key值
			expands: [],
			// hosps: [],
			radio: '',
			hosps: [],
			fullscreenLoading: false,
			domains: [{
				index: '',
				statime: '',
				endtime: '',
			}],
			// 选择机构发布任务
			checkList: [],
			orgcode: [],
			//机构报表
			arrays: [],
			// 学生送训费报表
			arrayss: [],
			// 学生送训费报表
			arrayss1: [],
			arrayss0: [],
			// 未确认机构报表
			unqueren: [],
			// 未拨款报表
			nomoney: [],
			// 已拨款报表 
			wancheng: [],
			tishi: 0,
			bbtype: 0,
			// 选择时间段弹窗
			dialogVisible: false,
			// 选中机构发布任务弹窗
			dialogVisibles: false,
			// 发票弹窗
			dialogVisiblev1: false,
			// 发票弹窗
			dialogVisiblev2: false,
			// 未拨款发票弹窗判断
			dialogVisiblev3: 0,
			// 导出表弹窗
			dialogVisiblevd: false,
			orgneirong:[]
		}
	},
	watch: {
		radio: {
			async handler() {
				if (this.radio == 'undefined') {
					this.radio = ''
					console.log(this.radio, "this.radio");
					this.openjieduan()
				}
				else if (this.radio.statime.length == 0 || this.radio.statime.length == 0) {
					this.radio = ''
					this.openjieduan()
				}
				else {
					this.orgcode = []
					this.checkList = []
					console.log(this.radio, "this.radio");
					this.dialogVisibles = true
				}
			}
		},
		years:{
			async handler() {
				await this.shuaxin()
			}
		}
	},
	computed: {
		info() {
			let info = window.localStorage.getItem("info");
			return JSON.parse(info);
		},
		org() {
			let org = window.localStorage.getItem("org");
			return JSON.parse(org);
		},teatoken(){
			return window.localStorage.getItem("tea_token");
		},
	},
	mounted() {
		// setInterval(() => {
		// 	this.shuaxinv1()
		// }, 3500);
	},
	methods: {

		fp_statuss(){
			let val = this.orgneirong
			if(this.dialogVisiblev3!=1){
				this.$alert('资金发票无误，点击确认', '', {
				confirmButtonText: '确定',
				callback: async action => {
					if (action == 'confirm') {
						let loadingInstance = Loading.service({ fullscreen: true });
						loadingInstance
						let ans = await axios.get(this.$urls + 'canlian/updata_money_fp', {
							params: {
								money_id: val.money_id,
								org_id: val.org_id,
								area: this.org.name
							},headers: {
								"token": this.teatoken
							}
						});
						if (ans.data.status == '1') {
							this.shuaxin()
							loadingInstance.close();
							this.dialogVisiblev2=false
						} else {
							this.$nextTick(() => {
								loadingInstance.close();
							});
						}
						
					} else {
						this.$message({
							type: 'info',
							message: "Error"
						});
					}

				}
			});
			}else{
				this.dialogVisiblev3==0
				this.$alert('您已确认资金发票无误,点击拨款' , {
				confirmButtonText: '确定',
				callback: async action => {
					if (action == 'confirm') {
						let loadingInstance = Loading.service({ fullscreen: true });
						loadingInstance
						let ans = await axios.get(this.$urls + 'canlian/updata_money_org_bf', {
							params: {
								money_id: val.money_id,
								org_id: val.org_id,
								area: this.org.name
							},headers: {
								"token": this.teatoken
							}
						});
						this.orgneirong=[]
						this.dialogVisiblev2=false
						if (ans.data.status == '1') {
							this.$nextTick(() => {
								loadingInstance.close();
							});
							this.shuaxin()
							this.$alert('已确认拨款', {
								confirmButtonText: '确定',
							});
						} else {
							this.$nextTick(() => {
								loadingInstance.close();
							});
						}
					} else {
						this.$message({
							type: 'info',
							message: "Error"
						});
					}

				}
			});
			}
			
		},

		async shuaxinv1() {
			let res = await axios.get(this.$urls + 'canlian/money_canlian_select', {
				params: {
					year: this.years.getFullYear(),
					qu_id: this.org.area
				},headers: {
					"token": this.teatoken
				}
			});
			console.log(res.data, "机构完成状态");
			let difference = find(this.duibi, res.data);
			console.log(difference, "difference");
			if (difference == true) {
				this.shuaxin()
				console.log(difference, "difference22222222");
			}
		},
		// 刷新数据
		shuaxin() {
			// 选择机构发布任务
			this.dialogVisiblev3=0,
			this.domains=[]
			this.checkList = [],
				this.orgcode = [],
				//机构报表
				this.arrays = [],
				// 学生送训费报表
				this.arrayss = [],
				// 学生送训费报表
				this.arrayss1 = [],
				this.arrayss0 = [],
				// 未确认机构报表
				this.unqueren = [],
				// 未拨款报表
				this.nomoney = [],
				// 已拨款报表
				this.wancheng = [],

				this.huoqujigou()
			this.orgss()
			// 已拨款报表
		},
		// 导出sexl表的弹窗
		daochu() {
			this.dialogVisiblevd = true
		},
		// 开导
		daochubiao() {
			console.log(this.value, "this.value");
			let a = []
			if (this.value == "机构报表") {
				a = this.arrays
			} else if (this.value == "送训费报表") {
				a = this.arrayss
			} else {
				this.$alert('请正确选择内容', {
					confirmButtonText: '确定',
					callback: action => {
					}
				});
			}
			this.$alert('已经下载...', {
				confirmButtonText: '确定',
				callback: action => {
				}
			});
			this.dialogVisiblevd = false
		},
		// 查看发票
		chakanfapapiao(val) {
			this.url = ''
			this.srcList = []
			this.dialogVisiblev1 = true
			console.log(val.money_img, "chakanfapapiao");
			this.url = val.money_img
			this.srcList.push(val.money_img)
		},
		// 未拨款查看发票
		chakanfapapiaov1(val) {
			this.dialogVisiblev3=0
			this.orgneirong=val
			this.url = ''
			this.srcList = []
			this.dialogVisiblev2 = true
			console.log(val.money_img, "chakanfapapiao");
			this.url = val.money_img
			this.srcList.push(val.money_img)
		},
		//下载出勤表
		downloadFile(val) {
			console.log(val.chuqin, "idididid");
			if(val.chuqin!=0){
				this.$alert('跳转后按 ctrl+s 保存即可正常查看考勤表', {
				confirmButtonText: '确定',
				callback: action => {
					window.open(val.chuqin, '_blank')
				}
			});
			}else{
				this.$alert('出勤表错误，请重新选择', {
				confirmButtonText: '确定',
				
			});
			}
			
		},
		//未拨款确认拨款按钮
		async handleClickv3(val) {
			console.log(val, "未拨款确认拨款按钮");
			this.orgneirong=val
			if(val.fp_status!=1){
				this.dialogVisiblev3=1
			this.url = ''
			this.srcList = []
			this.dialogVisiblev2 = true
			console.log(val.money_img, "chakanfapapiao");
			this.url = val.money_img
			this.srcList.push(val.money_img)
			}else{
				this.dialogVisiblev3==0
				this.$alert('您已确认资金发票无误,点击拨款' , {
				confirmButtonText: '确定',
				callback: async action => {
					if (action == 'confirm') {
						let loadingInstance = Loading.service({ fullscreen: true });
						loadingInstance
						let ans = await axios.get(this.$urls + 'canlian/updata_money_org_bf', {
							params: {
								money_id: val.money_id,
								org_id: val.org_id,
								area: this.org.name
							},headers: {
								"token": this.teatoken
							}
						});
						this.orgneirong=[]
						this.dialogVisiblev2=false
						if (ans.data.status == '1') {
							this.$nextTick(() => {
								loadingInstance.close();
							});
							this.shuaxin()
							this.$alert('已确认拨款', {
								confirmButtonText: '确定',
							});
						} else {
							this.$nextTick(() => {
								loadingInstance.close();
							});
						}
					} else {
						this.$message({
							type: 'info',
							message: "Error"
						});
					}

				}
			});
			}
			

		},
		//未拨款确认拨款按钮
		async bohuiv3() {
			let val = this.orgneirong
			console.log(val, "未拨款确认拨款按钮");

			this.$alert('资金发票有误', '点击驳回', {
				confirmButtonText: '确定',
				callback: async action => {
					if (action == 'confirm') {
						let loadingInstance = Loading.service({ fullscreen: true });
						loadingInstance
						let ans = await axios.get(this.$urls + 'canlian/updata_money_org_bfv2', {
							params: {
								area: this.org.name,
								money_id: val.money_id,
								org_id: val.org_id
							},headers: {
								"token": this.teatoken
							}
						});
						if (ans.data.status == '1') {
							this.dialogVisiblevd=false
							this.$nextTick(() => {
								loadingInstance.close();
							});
							this.shuaxin()
							this.$alert('已成功驳回', {
								confirmButtonText: '确定',
							});
						} else {
							this.dialogVisiblevd=false
							this.$nextTick(() => {
								
								loadingInstance.close();
							});
						}
					} else {
						this.$message({
							type: 'info',
							message: "Error"
						});
					}

				}
			});
		},

		//未确认机构 确认按钮 
		async handleClickv2(val) {
			console.log(val, "handleClickv2");
			this.$alert('机构报表资金无误', '点击通知上传资金发票', {
				confirmButtonText: '确定',
				callback: async action => {
					if (action == 'confirm') {
						let loadingInstance = Loading.service({ fullscreen: true });
						loadingInstance
						let ans = await axios.get(this.$urls + 'canlian/updata_money_org', {
							params: {
								money_id: val.money_id,
								org_id: val.org_id
							},headers: {
								"token": this.teatoken
							}
						});
						if (ans.data.status == '1') {
							this.$nextTick(() => {
								loadingInstance.close();
							});
							this.shuaxin()
							this.$alert('已成功通知', {
								confirmButtonText: '确定',
							});
						} else {
							this.$nextTick(() => {
								loadingInstance.close();
							});
						}
					} else {
						this.$message({
							type: 'info',
							message: "Error"
						});
					}

				}
			});
		},
		//未确认机构  驳回按钮
		async bohuiv2(val) {
			console.log(val, "bohui");
			console.log(this.org.name, "bohui");
			let value = ''
			this.$alert(val.org_name, '点击确定驳回', {
				confirmButtonText: '确定',
				callback: async action => {
					if (action == 'confirm') {
						this.$prompt('请输入驳回原因', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							inputPattern: /.+/,
							inputErrorMessage: '不可为空'
						}).then(async ({ value }) => {
							value = value
							let a = val.statime.split("-")
							let loadingInstance = Loading.service({ fullscreen: true });
							loadingInstance
							let ans = await axios.get(this.$urls + 'canlian/updata_money_orgv2', {
								params: {
									canlian_name: this.org.name,
									qu_id: this.org.area,
									money_id: val.money_id,
									org_id: val.org_id,
									sta_time: val.statime,
									end_time: val.endtime,
									year: a[0],
									value: value
								},headers: {
									"token": this.teatoken
								}
							});
							if (ans.data.status == '1') {
								this.$nextTick(() => {
									loadingInstance.close();
								});
								this.shuaxin()
								this.$alert('已成功驳回', {
									confirmButtonText: '确定',
								});

							} else {
								this.$nextTick(() => {
									loadingInstance.close();
								});
							}
						}).catch(() => {
							console.log(value, "value驳回");
						});
					} else {
						this.$message({
							type: 'info',
							message: "Error"
						});
					}

				}
			});
		},
		clickRowHandle(row, column, event) {
			console.log(22222222222);
			if (this.expands.includes(row.id)) {
				this.expands = this.expands.filter(val => val !== row.id);
			} else {
				this.expands.push(row.id);
			}
		},
		handleClosev1() {
			this.hosps = []
			this.checkList = []
			this.orgss()
			this.dialogVisibles = false;
			this.radio = '';
			console.log(this.checkList,);
		},
		// 选择机构发布任务取消按钮
		quxiao() {
			this.hosps = []
			this.checkList = []
			this.orgss()
			this.dialogVisibles = false;
			this.radio = '';
			console.log(this.checkList,);
		},
		// 获取要选择结算资金的机构
		async orgss() {
			let loadingInstance = Loading.service({ fullscreen: true });
			loadingInstance
			let ans = await axios.get(this.$urls + 'canlian/asd_kf_hospsv1', {
				params: {
					qu_id: this.org.area
				},headers: {
					"token": this.teatoken
				}
			});
			console.log(ans, "获取要选择结算资金的机构");
			if (true) {
				this.$nextTick(() => {
					loadingInstance.close();
				});
			}
			ans.data.lists.map(async p => {
				this.hosps.push({
					value: p.id,
					label: p.org_name,
					name: p.code
				});
			});
			console.log(this.hosps,"this.hospsthis.hospsthis.hosps");
		},
		// 选择资金结算机构,发布任务
		async Task() {
			console.log(this.checkList,"this.checkListthis.checkList");
			if (this.checkList.length == 0) {
				this.checkList = []
				this.$alert('机构选择错误', '请核对选择的机构', {
					confirmButtonText: '确定',
				});
			} else {
				this.fullscreenLoading = true;

				for (let i = 0; i < this.checkList.length; i++) {
					this.orgcode.push({
						org_id: this.checkList[i].value
					})
					console.log(this.checkList[i].value, "this.checkList[i].value");
				}
				this.dialogVisibles = false
				this.fullscreenLoading = false;
				let loadingInstance = Loading.service({ fullscreen: true });
				loadingInstance
				let ans = await axios.post(this.$urls + 'canlian/canlian_money_Task_insert', {
					params: {
						org_list: this.orgcode,
						start_time: this.radio.statime,
						end_time: this.radio.endtime,
						qu_id: this.org.area,
						area: this.org.name
					},headers: {
						"token": this.teatoken
					}
				});
				this.hosps = [],
					this.orgss()
				if (ans.data.desc == '成功') {
					this.$nextTick(() => {
						loadingInstance.close();
					});
					this.fullscreenLoading = false;
					this.$message({
						message: '任务已经发布',
						type: 'success'
					});
					this.dialogVisibles = false
					this.shuaxin()
				} else {
					this.$nextTick(() => {
						loadingInstance.close();
					});
					this.fullscreenLoading = false;
					this.$message({
						message: 'Error',
						type: 'warning'
					});
					this.dialogVisibles = false
				}
			}
			console.log(this.checkList,);
		},
		toggleSelection(rows) {
			console.log(11111111111111);
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},

		handleSelectionChange(val) {
	
			let c = this.radio.statime
			let cc = this.radio.endtime
			if(this.duibi.length!=0){
				for (let b = 0; b < val.length; b++) {
				
				for (let a = 0; a < this.duibi.black.length; a++) {

					if (this.duibi.black[a].jigou.org_name == val[b].label && this.duibi.black[a].jigou.startime == c && this.duibi.black[a].jigou.endtime == cc) {
						if (val.length == 1) {
							val = ''
						} else {
							val.splice(b)
						}
						this.openv2(val[b].label)

					}
				}
				for (let a = 0; a < this.duibi.bai.length; a++) {
					console.log(this.duibi.bai[a].jigou, "111111111111111111111");
					if (this.duibi.bai[a].jigou.org_name == val[b].label && this.duibi.bai[a].jigou.startime == c && this.duibi.bai[a].jigou.endtime == cc) {

						if (val.length == 1) {
							val = ''
						} else {
							val.splice(b)
						}

						this.openv2()

					}
				}
			}
			this.multipleSelection = val;
			this.checkList = val
			}else{
				
			}
			

			this.multipleSelection = val;
			this.checkList = val


			console.log(val, "valvalvalva11111111111111111");
			// this.radio = 1;


		},
		jieduan() {
			this.dialogVisible = true
		},

		handleClose(done) {
			done();
		},
		// 获取接收到任务并上报资金数目的机构名单
		async huoqujigou() {
			let res = await axios.get(this.$urls + 'canlian/money_canlian_select', {
				params: {
					year: this.years.getFullYear(),
					qu_id: this.org.area
				},headers: {
					"token": this.teatoken
				}
			});
			console.log(res.data, "获取接收到任务并上报资金数目的机构名单机构完成状态");
			this.duibi = res.data
			if (res.data.black.length != 0) {
				//机构资金数目未上传
				res.data.black.map(async p => {
					
					let aaa = 0
					for (let g = 0; g < p.stu.length; g++) {
						aaa = +p.stu[g].sxf
						if (p.stu[g].stu_id_qr == 0) {
							this.arrayss0.push(p.stu[g])
						} else if (p.stu[g].stu_id_qr == 1) {
							this.arrayss1.push(p.stu[g])
						}
						this.arrayss.push(
							p.stu[g]
						)
					}
					
					//确认资金无误&&老师上传资金发票 未拨款的机构
					if (p.jigou.org_qr==1&&p.jigou.sexl!="null") { 
						console.log(this.nomoney,"this.nomoney");
						this.nomoney.push({
							org_name: p.jigou.org_name,
							stu: p.stu.length,
							money_sum: p.jigou.money_sum,
							zhuangtai: 0,
							money_id: p.jigou.money_id,
							money_img: this.$urlss + '/' + p.jigou.money_img,
							sxf: aaa,
							org_id: p.jigou.org_id,
							qrtime: p.jigou.time_insert,
							chuqin: this.$urlss + '/' +p.jigou.sexl.substring(0),
							statime: p.jigou.startime,
							endtime: p.jigou.endtime,
							fp_status:p.jigou.fp_status

						});
					}else if(p.jigou.org_qr==1) {
						this.nomoney.push({
							org_name: p.jigou.org_name,
							stu: p.stu.length,
							money_sum: p.jigou.money_sum,
							zhuangtai: 0,
							money_id: p.jigou.money_id,
							money_img: this.$urlss + '/' + p.jigou.money_img,
							sxf: aaa,
							org_id: p.jigou.org_id,
							qrtime: p.jigou.time_insert,
							chuqin:0,
							statime: p.jigou.startime,
							endtime: p.jigou.endtime,
							fp_status:p.jigou.fp_status
						});
						}


					//  未确认的机构
					if (p.jigou.org_qr == 0&&p.jigou.sexl != null) {
						this.unqueren.push({
							org_name: p.jigou.org_name,
							stu: p.stu.length,
							money_id: p.jigou.money_id,
							money_sum: p.jigou.money_sum,
							zhuangtai: 0,
							money_img: this.$urlss + '/' + p.jigou.money_img,
							sxf: aaa,
							org_id: p.jigou.org_id,
							qrtime: p.jigou.time_insert,
							chuqin: this.$urlss +'/' + p.jigou.sexl.substring(0),
							statime: p.jigou.startime,
							endtime: p.jigou.endtime,
							fp_status:p.jigou.fp_status
						});
					}else if(p.jigou.org_qr == 0){
						this.unqueren.push({
							org_name: p.jigou.org_name,
							stu: p.stu.length,
							money_id: p.jigou.money_id,
							money_sum: p.jigou.money_sum,
							zhuangtai: 0,
							money_img: this.$urlss + '/' + p.jigou.money_img,
							sxf: aaa,
							org_id: p.jigou.org_id,
							qrtime: p.jigou.time_insert,
							chuqin: 0,
							statime: p.jigou.startime,
							endtime: p.jigou.endtime,
							fp_status:p.jigou.fp_status
						});
					}
					if (p.jigou.sexl != 'null') {
						this.arrays.push({
							org_name: p.jigou.org_name,
							stu: p.stu.length,
							money_sum: p.jigou.money_sum,
							zhuangtai: 0,
							money_id: p.jigou.money_id,
							money_img: this.$urlss + '/' + p.jigou.money_img,
							sxf: aaa,
							org_id: p.jigou.org_id,
							qrtime: p.jigou.time_insert,
							chuqin: this.$urlss +'/' + p.jigou.sexl.substring(0),
							statime: p.jigou.startime,
							endtime: p.jigou.endtime,
							fp_status:p.jigou.fp_status
						});
					} else {
						this.arrays.push({
							org_name: p.jigou.org_name,
							stu: p.stu.length,
							money_sum: p.jigou.money_sum,
							zhuangtai: 0,
							money_id: p.jigou.money_id,
							money_img: this.$urlss + '/' + p.jigou.money_img,
							sxf: aaa,
							org_id: p.jigou.org_id,
							qrtime: p.jigou.time_insert,
							chuqin: 0,
							statime: p.jigou.startime,
							endtime: p.jigou.endtime,
							fp_status:p.jigou.fp_status
						});
					}
				});

			}
			if (res.data.bai.length != 0) {
				//已完成资金数目上传
				res.data.bai.map(async p => {
					let ccc = 0
					for (let g = 0; g < p.stu.length; g++) {
						ccc = +p.stu[g].sxf
						if (p.stu[g].stu_id_qr == 0) {
							this.arrayss0.push(p.stu[g])
						} else if (p.stu[g].stu_id_qr == 1) {
							this.arrayss1.push(p.stu[g])
						}
						this.arrayss.push(
							p.stu[g]
						)
					}
					//残联确认资金发放 已完成机构
					if(p.jigou.sexl=="null"){
						this.wancheng.push({
							org_name: p.jigou.org_name,
							stu: p.stu.length,
							money_sum: p.jigou.money_sum,
							zhuangtai: 1,
							money_id: p.jigou.money_id,
							money_img: this.$urlss + '/' + p.jigou.money_img,
							sxf: ccc,
							org_id: p.jigou.org_id,
							qrtime: p.jigou.time_insert,
							chuqin: 0,
							statime: p.jigou.startime,
							endtime: p.jigou.endtime,
							fp_status:p.jigou.fp_status
						});
					}else{
						this.wancheng.push({
							org_name: p.jigou.org_name,
							stu: p.stu.length,
							money_sum: p.jigou.money_sum,
							zhuangtai: 1,
							money_id: p.jigou.money_id,
							money_img: this.$urlss + '/' + p.jigou.money_img,
							sxf: ccc,
							org_id: p.jigou.org_id,
							qrtime: p.jigou.time_insert,
							chuqin: this.$urlss +'/' + p.jigou.sexl.substring(0),
							statime: p.jigou.startime,
							endtime: p.jigou.endtime,
							fp_status:p.jigou.fp_status
						});
					}
						
					 
					if(p.jigou.sexl!="null"){
						this.arrays.push({
						org_name: p.jigou.org_name,
						stu: p.stu.length,
						money_sum: p.jigou.money_sum,
						zhuangtai: 1,
						money_id: p.jigou.money_id,
						money_img: this.$urlss + '/' + p.jigou.money_img,
						sxf: ccc,
						org_id: p.jigou.org_id,
						qrtime: p.jigou.time_insert,
						chuqin: this.$urlss + '/' +p.jigou.sexl.substring(0),
						statime: p.jigou.startime,
						endtime: p.jigou.endtime,
						fp_status:p.jigou.fp_status
					});
					}else{
						this.arrays.push({
						org_name: p.jigou.org_name,
						stu: p.stu.length,
						money_sum: p.jigou.money_sum,
						zhuangtai: 1,
						money_id: p.jigou.money_id,
						money_img: this.$urlss + '/' + p.jigou.money_img,
						sxf: ccc,
						org_id: p.jigou.org_id,
						qrtime: p.jigou.time_insert,
						chuqin: 0,
						statime: p.jigou.startime,
						endtime: p.jigou.endtime,
						fp_status:p.jigou.fp_status
					});
				}
					

				});
			}

			console.log(this.arrayss0,"this.arrayss0");
			// 已有时间
			if (this.arrays.length != 0) {
				this.domains = []
				for (let gg = 0; gg < this.arrays.length; gg++) {
					this.domains.push({
						statime: this.arrays[gg].statime,
						endtime: this.arrays[gg].endtime,
					})
				}
				for (let s = 0; s < this.domains.length; s++) {
					for (let h = s + 1; h < this.domains.length; h++) {
						if (this.domains[s].statime == this.domains[h].statime && this.domains[s].endtime == this.domains[h].endtime) {
							this.domains.splice(h, 1);
							h--;
						}
					}
				}
				// for (let bb = 0; bb < this.domains.length; bb++) {
				// 	console.log(this.domains[bb]);
				// 	for (let b = 0; b < this.domains.length - bb; b++) {
				// 		console.log(this.domains[b]);
				// 		if (this.domains[b].statime != undefined && this.domains[b + 1].statime != undefined) {
				// 			console.log(this.domains[b].statime, this.domains[b + 1].statime);
				// 			console.log(this.domains[b].statime > this.domains[b + 1].statime);
				// 			if (this.domains[b].statime > this.domains[b + 1].statime) {
				// 				console.log(this.domains[b], "111");
				// 				let a = this.domains[b];
				// 				this.domains[b] = this.domains[b + 1];
				// 				console.log(this.domains[b + 1], "11122222");
				// 				this.domains[b + 1] = a;
				// 			}
				// 		}
				// 	}
				// }
				if (this.tishi == 0) {
					this.openv1()
				}

			} else {
				this.$alert('暂无时间段，请选择', {
					confirmButtonText: '确定',
					callback: action => {
						if (action == "confirm") {
							this.dialogVisible = true
						} else {
							this.dialogVisible = false
						}

					}
				});

			}
		},
		// 时间段选择提交
		submitForm(formName) {
			let b = 0
			for (let i = 0; i < this.domains.length; i++) {
				if (this.domains[i].statime == null || this.domains[i].endtime == null) {
					b += 1
				} else
					if (this.domains[i].statime.length == 0 || this.domains[i].endtime.length == 0) {
						b += 1
					} else if (this.domains[i].statime >= this.domains[i].endtime) {
						b += 1
					} else if (this.domains[i].statime == undefined || this.domains[i].endtime == undefined) {
						b += 1
					}
			}
			if (b == 0) {
				if (this.tishi == 0) {
					this.openv1()
				}

				this.dialogVisible = false
			} else {
				this.open()
			}
		},
		// 时间错误，请仔细核对
		open() {
			this.$alert('时间错误，请仔细核对', {
				confirmButtonText: '确定',
				callback: action => {
					// this.$message({
					//   type: 'info',
					//   message: `action: ${ action }`
					// });
				}
			});
		},
		// 该机构已在此时间段有相关任务
		openv2() {
			this.$alert('该机构已在此时间段有相关任务', {
				confirmButtonText: '确定',
				callback: action => {
					this.hosps = []
					this.orgss()
				}
			});
		},
		// 点击选中的时间段即可选择机构发布任务
		openv1() {
			this.tishi = 1
			this.$alert('点击选中的时间段即可选择机构发布任务', {
				confirmButtonText: '确定',
				callback: action => {
					// this.$message({
					//   type: 'info',
					//   message: `action: ${ action }`
					// });
				}
			});
		},
		// 阶段时间错误，请仔细核对
		openjieduan() {
			this.$alert('阶段时间错误，请仔细核对', {
				confirmButtonText: '确定',
				callback: action => {
					// this.$message({
					//   type: 'info',
					//   message: `action: ${ action }`
					// });
				}
			});
		},
		removeDomain(item) {
			var index = this.domains.indexOf(item)
			if (index !== -1) {
				this.domains.splice(index, 1)
			}
		},
		// 加载弹窗
		// openv1() {
		// 	this.tishi = 1
		// 	this.$alert('执行中', {
		// 		confirmButtonText: '确定',
		// 		callback: action => {
		// 			// this.$message({
		// 			//   type: 'info',
		// 			//   message: `action: ${ action }`
		// 			// });
		// 		}
		// 	});
		// },
		addDomain() {
			this.domains.push({
				index: false,
				statime: '',
				endtime: '',
				key: Date.now()
			});
			if (this.domains.length > 1) {
				for (let i = 1; i < this.domains.length; i++) {
					this.domains[i].statime = this.domains[i - 1].endtime
				}
			}

		}
	},
	async created() {
		await this.orgss()
		await this.huoqujigou()
	}
}

</script>

<style>
.demo-table-expand {
	font-size: 0;
}

.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}

.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}

.box {
	display: flex;
	flex-direction: column;
}

.fst {
	display: flex;
	flex-direction: row;
}

.box1 {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
}

.box01 {
	width: 90%;
	display: flex;
	flex-direction: column;
	margin-top: 10px;
}

.box02 {
	display: flex;
	flex-direction: column;
}

.aflex {
	display: flex;
	justify-content: space-around;
	align-items: center;
}
</style>